import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onBeforeUnmount } from 'vue'
// Element UI's Checkbox isn't globally registered. Import unaliased — the
// babel-plugin-component on-demand resolver derives the lib path from the local
// binding name, so the names MUST stay Checkbox / CheckboxGroup (an alias like
// ElCheckbox would make it look for element-ui/lib/el-checkbox, which 404s).
// Used in template as <checkbox> / <checkbox-group>.
import { Checkbox, CheckboxGroup } from 'element-ui'
import InfoHint from '@/components/InfoHint.vue'

interface Group {
  id: number
  name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CopySurveyDrawer',
  props: {
    show: { type: Boolean },
    survey: null,
    groups: null,
    sourceGroupId: null,
    loading: { type: Boolean }
  },
  emits: ["close", "copy"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'copy', groupIds: number[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean
  survey: { id?: number; name?: string } | null
  groups: Group[]
  // Source group id — excluded from the target list (can't copy onto itself).
  sourceGroupId?: number | null
  loading?: boolean
}





const selectedIds = ref<number[]>([])

const surveyName = computed(() => props.survey?.name || 'this survey')

const eligibleGroups = computed<Group[]>(() =>
  (props.groups || []).filter((g) => Number(g.id) !== Number(props.sourceGroupId))
)

const allSelected = computed(
  () => eligibleGroups.value.length > 0 && selectedIds.value.length === eligibleGroups.value.length
)

const isIndeterminate = computed(
  () => selectedIds.value.length > 0 && !allSelected.value
)

const copyLabel = computed(() => {
  const n = selectedIds.value.length
  if (n <= 1) return 'Copy'
  return `Copy to ${n} groups`
})

function toggleAll(checked: boolean) {
  selectedIds.value = checked ? eligibleGroups.value.map((g) => g.id) : []
}

function onClose() {
  emit('close')
}

function onCopy() {
  if (selectedIds.value.length === 0) return
  emit('copy', [...selectedIds.value])
}

function onEscKey(e: KeyboardEvent) {
  if (e.key === 'Escape' && props.show) onClose()
}

watch(
  () => props.show,
  (visible) => {
    if (visible) {
      selectedIds.value = []
      document.addEventListener('keydown', onEscKey)
    } else {
      document.removeEventListener('keydown', onEscKey)
    }
  }
)

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onEscKey)
})

return { __sfc: true,props, emit, selectedIds, surveyName, eligibleGroups, allSelected, isIndeterminate, copyLabel, toggleAll, onClose, onCopy, onEscKey, Checkbox, CheckboxGroup, InfoHint }
}

})